module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/ko_5-b56ad6fda39c1f17e8f1af60845afe4e.jpg";